export default __webpack_public_path__ + "ecca730ae85eb3f5da9234ed5fa84a6b.png";